import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers, MOCKUP_URL } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * buyers.length));
      setMinutes(1 + Math.floor(Math.random() * 9));
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed inset-x-3 bottom-[92px] z-50 flex justify-start sm:inset-x-auto sm:left-5 sm:bottom-24" data-id="element-43" data-mp="1657lb504nvzr">
      <AnimatePresence data-id="element-44" data-mp="116miqyxel085">
        {open && !dismissed && <motion.div role="status" aria-live="polite" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-2xl" data-id="element-45" data-mp="1fw2604xq6nj3">
            <img src={MOCKUP_URL} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-ink object-contain p-1" data-id="element-46" data-mp="s6hjjc2d5852" />
            <div className="min-w-0 text-ink" data-id="element-47" data-mp="28jy7ro25j5mq">
              <p className="text-sm font-bold leading-tight" data-id="element-48" data-mp="28imyj8pxt5o8">
                {buyer.name} from {buyer.country}
              </p>
              <p className="text-[13px] leading-snug text-slate-600" data-id="element-49" data-mp="2aol3ubat2827">just purchased the No-Start Diagnostic Blueprint™</p>
              <p className="mt-1 flex items-center gap-1 text-xs font-semibold text-green-700" data-id="element-50" data-mp="2fmv3ay3kbutm">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-51" data-mp="2kmhfr5bkh71d" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-md p-1 text-slate-400 hover:text-slate-700" data-id="element-52" data-mp="2pjhj38h17vos">
              <XIcon className="h-4 w-4" data-id="element-53" data-mp="21vhmhrx1hb2a" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}